export default [
  {
    path: '/audiencia/:uuid',
    name: 'audiencia',
    component: () => import('../../views/audiencia/index.vue'),
    meta: {
      pageTitle: 'Gerenciar Audiências',
    },
  },
  {
    path: '/audiencia/:uuid/segmentacao',
    name: 'audiencia-segmentacao',
    component: () => import('../../views/audiencia/Segmentacao.vue'),
    meta: {
      pageTitle: 'Segmentação',
    },
  },
  {
    path: '/audiencia/:uuid/rfm',
    name: 'audiencia-rfm',
    component: () => import('../../views/audiencia/RFMAudiencia.vue'),
    meta: {
      pageTitle: 'Audiência RFM',
    },
  },
]
